import { createFileRoute } from "@tanstack/react-router";

import { buildSeo } from "@/lib/seo";
import { MarketingLayout } from "@/components/marketing/Layout";
import { LegalDocument } from "@/components/legal/LegalDocument";
import { TERMS_DE, TERMS_EN } from "@/lib/legal/terms";

export const Route = createFileRoute("/terms")({
  head: () =>
    buildSeo({
      path: "/terms",
      title: "Terms of Service — Reality Twin Network",
      description:
        "Terms governing the Reality Twin platform: AI Twin limits, marketplace brokerage, payouts, and liability under Swiss law.",
    }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <MarketingLayout>
      <LegalDocument de={TERMS_DE} en={TERMS_EN} />
    </MarketingLayout>
  );
}
